import 'angular-hotkeys';
import userServiceModule from '../../services/userService/userService';
import maIsohService from "../../services/maIsohService/maIsohService";
import carDimensionsModule from "../../services/carDimensions/carDimensions";
import carPartsDimensionsModule from "../../services/carPartsDimensions/carPartsDimensions";
import carsServiceModule from "../../services/carsService/carsService";

import appName from './../../appName';
import notificationService from "../../services/notificationService/notificationService";

export default angular.module('WelcomeWizard', [
	'ui-notification',
	'cfp.hotkeys',
	userServiceModule,
	carDimensionsModule,
	carPartsDimensionsModule,
	carsServiceModule,
	maIsohService,
	notificationService
]).controller('WelcomeWizardController', function($scope, $rootScope, Notification, hotkeys, userService, $log, maIsoh, carDimensions, carPartsDimensions, carsService, $timeout, $state, notify) {
	this.close = () => {
		$scope.closeThisDialog(false);
	};
	
	$scope.altInputFormats = [
		'd.M.yyyy'
	];
	
	this.appName = appName;
	
	/**
	 * True value disable new behavior, that data
	 * for workplace and homeplace are loaded from server after login
	 * @type {boolean}
	 */
	this.showBigForm = false;
	
	this.model = userService.getUserSettings();
	this.appSettings = userService.getAppSettings();
	
	if (angular.isDefined(this.model.agreement.datum_vydani)) {
		this.model.agreement.datum_vydani = new Date(this.model.agreement.datum_vydani);
	}
	
	if (angular.isDefined(this.model.agreement.datum_souhlasu)) {
		this.model.agreement.datum_souhlasu = new Date(this.model.agreement.datum_souhlasu);
	}
	
	this.datumVydaniOpened = false;
	this.datumSouhlasuOpened = false;
	
	this.model.agreement.datum_vydani = new Date();
	
	// this.model.agreement.datum_souhlasu = new Date();
	
	/**
	 * Dimension selector callbacks
	 */
	this.workplacePscSelected = (selected) => {
		this.model.workplace.obec = selected.obec;
	};
	
	this.workplaceZujSelected = (selected) => {
		this.model.workplace.orp = selected.orp;
	};
	
	this.checkFacility = () => {
		maIsoh.getFacilityInfo(this.model.workplace.ic, this.model.workplace.zuj, this.model.workplace.provoz).then((response) => {
			if (angular.isDefined(response.json.zarizeni.ident)) {
				this.model.workplace.ident = response.json.zarizeni.ident;
				
				if (angular.isDefined(response.json.zarizeni.povolenoOd)) {
					this.model.agreement.datum_vydani = new Date(response.json.zarizeni.povolenoOd);
				} else {
					this.model.agreement.datum_vydani = '';
				}
				
				if (angular.isDefined(response.json.zarizeni.povolenoDo) && response.json.zarizeni.povolenoDo.length) {
					this.model.agreement.datum_souhlasu = new Date(response.json.zarizeni.povolenoDo);
				} else {
					if(!angular.isDefined(this.appSettings.rememberMe) || !this.appSettings.rememberMe) {
						this.model.agreement.datum_souhlasu = '';
						
					}
				}
				
				$log.debug('Zarizeni overeno');
				
				messages.push('Ověření informací o zařízení ... OK');
				messages.push('Spojení se serverem funguje');
				
				$timeout(() => {
					this.loadCarPartsDimensions();
				}, 500);
				
				$timeout(() => {
					this.loadCarDimensions();
				}, 1000);
			} else {
				$log.debug('Zarizeni neexistuje');
				throw new Error('Toto zařízení neexistuje');
			}
		}).then(() => {
			userService.setUserSettings(this.model);
			
			let finishProcess = () => {
				$scope.closeThisDialog({result: 'ok'});
				$state.go('autovraky.settings');
				messages.push('Před prvním použitím prosím zkontrolujte údaje v sekci Nastavení -> Zařízení');
				Notification.success(messages.join('<br>'));
				$rootScope.$broadcast('loginOk');
			};
			
			if(carsService.getCars().length > 0) {
				finishProcess();
			} else {
				carsService.loadCars().then(() => {
					messages.push('Stahuji autovraky z MA ISOH ... OK');
					finishProcess()
				});
			}
		}).catch((error) => {
			if (error.message) {
				Notification.error('Uživatelské jméno a heslo neodpovídá nastaveým parametrům zařízení. Zkontrolujte IČ, provoz a ZÚJ  - ' + error.message);
				$log.debug('Login a pass Ok ale zarizeni je blbe');
			}
		}).finally(() => {
			this.testingApi = false;
		});
	};
	
	this.selectedFacility = false;
	
	this.selectFacility = () => {
		this.saveAppSettings();
		
		this.selectedFacility = true;
		// Get all facilities
		maIsoh.getFacilityInfo(this.facility.ic, this.facility.zuj, this.facility.provoz).then((response) => {
			
			this.model.workplace.ic = response.json.zarizeni.ic;
			this.model.workplace.provoz = response.json.zarizeni.provoz;
			this.model.workplace.zuj = response.json.zarizeni.zuj;
			this.model.workplace.nazev = response.json.zarizeni.nazev;
			this.model.workplace.ulice = response.json.zarizeni.ulice;
			this.model.workplace.psc = response.json.zarizeni.psc;
			this.model.workplace.obec = response.json.zarizeni.obec;
			this.model.workplace.kontakt = response.json.zarizeni.kontakt;
			this.model.workplace.telefon = response.json.zarizeni.telefon;
			
			// Get base
			// maIsoh.getFacilityInfo(this.facility.ic, null, 0).then((response) => {
			//
			// 	this.model.homeplace.zuj = response.json.zarizeni.zuj;
			// 	this.model.homeplace.nazev = response.json.zarizeni.nazev;
			// 	this.model.homeplace.ulice = response.json.zarizeni.ulice;
			// 	this.model.homeplace.psc = response.json.zarizeni.psc;
			// 	this.model.homeplace.obec = response.json.zarizeni.obec;
			// });
			
			this.checkFacility();
		}).catch((error) => {
			if (error.message) {
				Notification.error('Uživatelské jméno a heslo neodpovídá nastaveým parametrům zařízení. Zkontrolujte IČ, provoz a ZÚJ  - ' + error.message);
				$log.debug('Login a pass Ok ale zarizeni je blbe');
			}
		}).finally(() => {
			this.testingApi = false;
		});
	};
	
	let messages = [];
	
	/**
	 * Test API by trying to get detail about this user
	 * Pyramid of doom callback hell is intetional, because ISOH API return the same error message on all messages
	 */
	this.testApi = () => {
		this.testingApi = true;
		this.needChangePassword = false;
		messages = [];
		
		Notification.info('Kontaktuji MA ISOH, strpení prosím, tento proces chvilku trvá');
		$log.debug('Kontakuji MA ISOH pro init sync');
		
		maIsoh.testApi().then((response) => {
			messages.push('Načtení informací o aplikaci ... OK');
			$log.debug('Info o APP nacteno');
			
			maIsoh.getUserInfo(this.appSettings.user.login).then(() => {
				messages.push('Ověření uživatelského jména a hesla ... OK');
				$log.debug('Username a pass overeno');
				
				if (this.showBigForm) {
					this.checkFacility();
				} else {
					// Load facility from API
					maIsoh.getFacilityList().then((response) => {
						//this happens when user dont have any railights assigned
						if (angular.isUndefined(response.json.list.item)) {
							Notification.error('Chyba při načítání zařízení, tento uživatel nemá v MA ISOH žádné zařízení');
							return;
						}
						
						if (!Array.isArray(response.json.list.item)) {
							response.json.list.item = [response.json.list.item];
						}
						
						this.facility = response.json.list.item[0];
						
						if (response.json.list.item.length === 1) {
							Notification.info('Máte pouze jedno zařízení: ' + this.facility.provoz + ' - ' + this.facility.nazev + ". Používám ho pro přihlášení do MA ISOH, strpení prosím");
							this.selectFacility();
						} else {
							this.facilitiesLoaded = response.json.list.item;
							Notification.info('Máte více než jedno zařízení, prosím, vyberte za které se chcete přihlásit');
						}
					}).catch((error) => {
					}).finally(() => {
						this.testingApi = false;
					});
				}
			}).catch((error) => {
				if (error.message) {
					if (error.message === 'Nelze provést tuto akci s jednorázovým heslem.') { //it would be cool if MA ISOH returned error code ...
						Notification.warning('Používáte jednorázové heslo');
						$log.debug('Pouziva jednorazove heslo -> jdeme menit');
						this.needChangePassword = true;
					} else {
						Notification.error('Uživatelské jméno nebo heslo není správné, ověřte správnost - ' + error.message);
						$log.debug('Login a pass je blbe');
					}
					
				}
				
				this.testingApi = false;
			});
		}).catch((error) => {
			if (error.message) {
				Notification.error('Spojení se službou nebylo navázáno - ' + error.message);
				$log.debug('Server nejde');
			}
			
			this.testingApi = false;
		});
	};
	
	this.changePassword = () => {
		this.changingPassword = true;
		
		if (angular.isUndefined(this.newPassword) || angular.isUndefined(this.newPassword)) {
			Notification.warning('Musíte zadat heslo');
			this.changingPassword = false;
			return;
		}
		
		if (this.newPassword !== this.newPassword2) {
			Notification.warning('Hesla nejsou shodná!');
			this.changingPassword = false;
			return;
		}
		
		if (this.newPassword.length < 8) {
			Notification.warning('Heslo musí být alespoň 8 znaků dlouhé');
			this.changingPassword = false;
			return;
		}
		
		maIsoh.changePassword(this.appSettings.user.login, this.appSettings.user.password, this.newPassword).then(() => {
			this.appSettings.user.password = this.newPassword;
			this.changingPassword = false;
			this.needChangePassword = false;
			this.save(this.wizardForm);
			$log.debug('Jednorazove heslo uspesne zmeneno');
		}).catch((error) => {
			Notification.error('Došlo k chybě při změně jednorázového hesla, kontaktujte technickou podporu prosím - ' + error.message);
			$log.debug('Bug pri zmene jednorazoveho hesla - ' + error.message);
		});
	};
	
	/**
	 * Load car dimensions from server
	 */
	this.loadCarDimensions = () => {
		this.loadingCarDimensions = true;
		maIsoh.loadCarDimensions(carDimensions.getLastSync()).then((result) => {
			if (angular.isDefined(result.json.znacky.item)) {
				carDimensions.setDimensions(result.json.znacky.item);
				
				this.carDimensionsCount = result.json.znacky.item.length;
				
				Notification.success('Číselník značek synchronizován - ' + this.carDimensionsCount + ' položek');
			} else {
				Notification.success('Číselník značek je aktuální');
			}
			
			carDimensions.markLastSync();
			this.carDimensionsLastSync = carDimensions.getLastSync();
			this.initCarDimensions();
		}).catch((error) => {
			Notification.error(error.message);
		}).finally(() => {
			this.loadingCarDimensions = false;
		});
	};
	
	/**
	 * Load car parts dimensions from server
	 */
	this.loadCarPartsDimensions = () => {
		this.loadingCarPartsDimensions = true;
		maIsoh.loadCarPartsDimensions(carPartsDimensions.getLastSync()).then((result) => {
			if (angular.isDefined(result.json.casti.item)) {
				carPartsDimensions.setDimensions(result.json.casti.item);
				this.carPartsDimensionsCount = result.json.casti.item.length;
				
				Notification.success('Číselník částí synchronizován - ' + this.carPartsDimensionsCount + ' položek');
			} else {
				Notification.success('Číselník částí je aktuální');
			}
			
			carPartsDimensions.markLastSync();
			this.carPartsDimensionsLastSync = carPartsDimensions.getLastSync();
			this.initCarPartsDimensions();
		}).catch((error) => {
			Notification.error(error.message);
		}).finally(() => {
			this.loadingCarPartsDimensions = false;
		});
	};
	
	this.initCarDimensions = () => {
		this.carDimensions = carDimensions.getDimensions();
		this.carDimensionsCount = this.carDimensions.length;
		this.carDimensionsLastSync = carDimensions.getLastSync();
	};
	
	this.initCarPartsDimensions = () => {
		this.carPartsDimensions = carPartsDimensions.getDimensions();
		this.carPartsDimensionsCount = this.carPartsDimensions.length;
		this.carPartsDimensionsLastSync = carPartsDimensions.getLastSync();
	};
	
	this.initCarDimensions();
	this.initCarPartsDimensions();
	
	this.wizardForm = {};
	
	/**
	 * Saves whole modal
	 */
	this.save = () => {
		this.saveAppSettings();
		this.testApi();
	};
	
	/**
	 * Save facility info
	 */
	this.saveFacility = (form) => {
		if (form.$valid) {
			userService.setUserSettings(this.model);
			Notification.success('Údaje uloženy');
		} else {
			Notification.error('Vyplňte prosím všechna povinná pole. Správně vyplněné pole je označeno zelenou barvou. Žlutá pole jsou povinná, bílá nepovinná');
		}
	};
	
	this.saveAppSettings = () => {
		userService.setAppSettings(this.appSettings);
	};
	
	/**
	 * Sets default server values
	 */
	this.setDefaultServer = () => {
		this.appSettings.apiUrl = 'https://autovraky.mzp.cz/autovrak/service/v7';
		this.appSettings.apiWSDLUrl = 'https://autovraky.mzp.cz/autovrak/service/wsdl/v7';
		this.saveAppSettings();
		
		notify.success('Prostředí nastaveno na ' + this.appSettings.apiUrl);
	};
	
	this.setTestingServer = () => {
		this.appSettings.apiUrl = 'https://autovraky-test.mzp.cz/autovrak/service/v7';
		this.appSettings.apiWSDLUrl = 'https://autovraky-test.mzp.cz/autovrak/service/wsdl/v7';
		this.saveAppSettings();
		
		notify.success('Prostředí nastaveno na ' + this.appSettings.apiUrl);
	};
	
	/**
	 * Hotkeys part
	 */
}).name;



// WEBPACK FOOTER //
// build/modules/home/welcomeWizard.js